import React from 'react'
import Form from '~/components/form'

export const PriceForm: React.FC = () => {
  return (
    <div className='onlinepbx__price__form'>
      <div className='onlinepbx__container'>
        <h2 className='onlinepbx__price__form__header'>
          Продавайте больше с <span
            className='onlinepbx__content__header__green'>online</span>
          <span
            className='onlinepbx__content__header__black'>pbx</span>
        </h2>
        <Form
          free
          text='Подключить'
          pageName='Цена'
        />
      </div>
      <div className='onlinepbx__price__bottom-line' />
    </div>
  )
}

export default PriceForm
